import * as z from 'zod';
export const TournamentSchema = z.strictObject({
    id: z.uuidv7(),
    slug: z.string().min(1),
    name: z.string().min(1),
    status: z.enum(['DRAFT', 'LIVE', 'COMPLETED']),
    createdAt: z.number().int().nonnegative(),
    updatedAt: z.number().int().nonnegative(),
    nifs: z
        .strictObject({
        tournamentId: z.string(),
        stageIds: z.array(z.string()),
        matchIds: z.array(z.string()),
        autogenerateQuestions: z.boolean().optional(),
    })
        .optional(),
});
export const RoundScheduleSchema = z.strictObject({
    eventStartsAt: z.number().int().nonnegative().optional().meta({
        description: 'When the live event this round represents starts. Answers submitted after this get 0 points',
    }),
    locksAt: z
        .number()
        .int()
        .nonnegative()
        .optional()
        .meta({ description: 'When the round is scheduled to lock automatically' }),
});
export const RoundKindSchema = z.enum(['NORMAL', 'LONG_LIVED']).meta({
    description: 'NORMAL rounds belong to a single event with a schedule. LONG_LIVED rounds stay open across the tournament (e.g. championship questions).',
});
export const RoundStateSchema = z.strictObject({
    openedAt: z.number().int().nonnegative().optional().meta({
        description: 'When the round opened (manual or automatic)',
    }),
    lockedAt: z
        .number()
        .int()
        .nonnegative()
        .optional()
        .meta({ description: 'When the round locked (manual or automatic)' }),
    completedAt: z
        .number()
        .int()
        .nonnegative()
        .optional()
        .meta({ description: 'When the round was administratively completed' }),
});
const NifsTeamSchema = z.strictObject({
    logo: z.url().optional(),
});
const NifsMatchStreamSchema = z.strictObject({
    id: z.number().int(),
    uid: z.string(),
    link: z.string(),
    radio: z.boolean(),
    customer: z.strictObject({
        id: z.number().int(),
        name: z.string(),
        host: z.string(),
    }),
    type: z.string(),
});
const NifsTvChannelSchema = z.strictObject({
    name: z.string(),
});
const RoundNifsSchema = z.strictObject({
    matchId: z.string(),
    homeTeam: NifsTeamSchema.optional(),
    awayTeam: NifsTeamSchema.optional(),
    matchStreams: z.array(NifsMatchStreamSchema).optional(),
    tvChannels: z.array(NifsTvChannelSchema).optional(),
});
export const RoundSchema = z.strictObject({
    id: z.uuidv7(),
    tournamentId: z.uuidv7(),
    name: z.string().min(1),
    kind: RoundKindSchema,
    schedule: RoundScheduleSchema.optional(),
    state: RoundStateSchema.optional(),
    createdAt: z.number().int().nonnegative(),
    updatedAt: z.number().int().nonnegative(),
    nifs: RoundNifsSchema.optional(),
});
export const RoundStatusSchema = z.enum([
    'DRAFT',
    'LIVE',
    'SCHEDULED_TO_LOCK',
    'LOCKED',
    'COMPLETED',
]);
export const deriveRoundStatus = (schedule, state) => {
    if (state?.completedAt != null) {
        return 'COMPLETED';
    }
    if (state?.lockedAt != null) {
        return 'LOCKED';
    }
    if (state?.openedAt != null) {
        if (schedule?.locksAt != null) {
            return 'SCHEDULED_TO_LOCK';
        }
        return 'LIVE';
    }
    return 'DRAFT';
};
//# sourceMappingURL=tournament.js.map